import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteSparePartId, setUpdateSparePartId} from "../../actions/spare_part";
import {Link} from 'react-router-dom'
import MoneyFormat from "../layout/MoneyFormat";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEdit, faTrash, faEye} from '@fortawesome/free-solid-svg-icons';
import {Button} from 'react-bootstrap';
import { usePermission } from '../../hooks/usePermission';
import { useManagerPermissions } from '../../hooks/useManagerPermissions';

const SparePartItem = ({
                           setDeleteSparePartId,
                           setUpdateSparePartId,
                           spare_part: {
                               id, name, in_stock, price, warehouse_id, warehouse, unit, unit_id,
                               firm, created_at, deleted_at
                           },
                           number
                       }) => {
    const { userCan } = usePermission();
    const { canManagerEditSparePart, canManagerDeleteSparePart } = useManagerPermissions();

    // Reconstruct spare part object for permission checking
    const sparePartObject = {
        id,
        name,
        in_stock,
        price,
        warehouse_id,
        warehouse,
        unit,
        unit_id,
        firm,
        created_at,
        deleted_at
    };

    if (!userCan('view spare parts')) {
        return null;
    }

    // Determine if the item is deleted
    const isDeleted = !!deleted_at;

    const setDeleteSparePart = (id) => {
        setDeleteSparePartId(id);
    };

    const setUpdateSparePart = (id) => {
        setUpdateSparePartId(id);
    };

    // Get firm name from the firm object
    const getFirmName = () => {
        return firm ? firm.name : '-';
    };

    return (
        <Fragment>
            <tr className={isDeleted ? 'table-danger deleted-item' : ''}>
                <th scope="row">{number}</th>
                <td>
                    <Link to={`/spare-parts/${id}`} className="text-decoration-none">
                        {name}
                    </Link>
                    {isDeleted && (
                        <span className="badge bg-danger ms-2">O'chirilgan</span>
                    )}
                </td>
                <td>{getFirmName()}</td>
                <td>
                    {userCan('view warehouses') && warehouse?.id ? (
                        <Link to={`/warehouses/${warehouse.id}`}>{warehouse?.name}</Link>
                    ) : (
                        warehouse?.name || '-'
                    )}
                </td>
                <td>{in_stock || 0}</td>
                <td>{unit?.name || '-'}</td>
                <td><MoneyFormat value={price}/> so'm</td>
                <td>
                    <div className="d-flex gap-2">
                        {userCan('view spare parts') && (
                            <Link to={`/spare-parts/${id}`}>
                                <Button
                                    variant="outline-info"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{width: '32px', height: '32px', padding: 0}}
                                >
                                    <FontAwesomeIcon icon={faEye}/>
                                </Button>
                            </Link>
                        )}
                        {canManagerEditSparePart(sparePartObject) && !isDeleted && (
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{width: '32px', height: '32px', padding: 0}}
                                onClick={() => setUpdateSparePart(id)}
                            >
                                <FontAwesomeIcon icon={faEdit}/>
                            </Button>
                        )}
                        {canManagerDeleteSparePart(sparePartObject) && !isDeleted && (
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{width: '32px', height: '32px', padding: 0}}
                                onClick={() => setDeleteSparePart(id)}
                            >
                                <FontAwesomeIcon icon={faTrash}/>
                            </Button>
                        )}
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

SparePartItem.defaultProps = {
    showActions: true,
};

SparePartItem.propTypes = {
    spare_part: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        in_stock: PropTypes.number,
        price: PropTypes.number,
        warehouse_id: PropTypes.number,
        warehouse: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            firm_id: PropTypes.number
        }),
        unit: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        }),
        firm: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        }),
        unit_id: PropTypes.number,
        created_at: PropTypes.string
    }).isRequired,
    number: PropTypes.number.isRequired,
    setDeleteSparePartId: PropTypes.func.isRequired,
    setUpdateSparePartId: PropTypes.func.isRequired
};

export default connect(null, {setDeleteSparePartId, setUpdateSparePartId})(SparePartItem);
